/* eslint-disable */
import { node } from "~/util/dom";
import { _ } from "~/i18n";

export interface ICheckboxTitle {
	onTitle: string;
	offTitle: string;
	checked: boolean;
	change: (checked: boolean) => void;
}

export default class CheckboxTitle {
	_opts: ICheckboxTitle;

	_dom: {
		container: HTMLLabelElement;
		switchEl: HTMLInputElement;
		indicator: HTMLSpanElement;
	};

	constructor(optsArg) {
		this._opts = {
			onTitle: _("route.weather.on"),
			offTitle: _("route.weather.off"),
			checked: false,
			change: null,
			...optsArg,
		};
		this._dom = {
			container: node("label", { className: "checkbox-title mx-switch-container switch" }),
			switchEl: node("input", { type: "checkbox" }),
			indicator: node("span", { className: "indicator" }),
		};

		this._build();
		this._set(this._opts.checked);
	}

	destroy() {
		this._dom.switchEl.removeEventListener("change", this);
		this._dom.container.remove();
	}

	get container() {
		return this._dom.container;
	}

	// change pro input
	handleEvent(e) {
		switch (e.type) {
			case "change":
				this._set(this._dom.switchEl.checked);
				this._sendEvent();
				break;

			default:
				//
		}
	}

	_build() {
		this._dom.container.appendChild(this._dom.indicator);
		this._dom.container.appendChild(this._dom.switchEl);
		this._dom.container.appendChild(node("span", { className: "slider" }));
		this._dom.switchEl.addEventListener("change", this);
	}

	_set(state) {
		this._dom.switchEl.checked = state;
		this._dom.indicator.textContent = state ? this._opts.onTitle : this._opts.offTitle;
		this._dom.indicator.classList[state ? "add" : "remove"]("checked");
	}

	_sendEvent() {
		this._opts.change && this._opts.change(this._dom.switchEl.checked);
	}
}
